import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import type { Invoice } from "@tfg/db"
import { DateCell, DocumentActionsCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { fetchDocumentUrl } from "~/hooks/useDocumentsQuery"

const columnHelper = createColumnHelper<Invoice>()
export const useColumns = (orgName: string) => {
  const { t } = useTranslation(["invoices", "common"])
  return useMemo<ColumnDef<Invoice, any>[]>(
    () => [
      columnHelper.accessor("issueDate", {
        header: t("invoices:columns.issueDate"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("reference", {
        header: t("invoices:columns.reference"),
      }),
      columnHelper.accessor("amount", {
        header: t("invoices:columns.amount"),
        cell: (info) => t("intlCurrency", { value: info.getValue() }),
      }),
      columnHelper.display({
        header: t("invoices:columns.actions"),
        cell: ({ row: { original: invoice } }) =>
          invoice.documentId ? (
            <DocumentActionsCell
              documentName={`invoice-${orgName}-${invoice.createdAt}`}
              documentId={invoice.documentId}
              fetchViewUrl={() => fetchDocumentUrl(invoice.documentId)}
              fetchDownloadUrl={() =>
                fetchDocumentUrl(invoice.documentId, true)
              }
              missingDocumentText={t("common:documentUpload.missingDocument")}
            />
          ) : null,
      }),
    ],
    [orgName, t]
  )
}
